// Feather icons the app renders through <Icon name="…" />. Named imports keep the other ~230
// icons out of the bundle; add a name here before using a new one.
import {
  AlertCircle, AlertTriangle, Anchor, Aperture, ArrowDown, ArrowDownCircle, ArrowLeft, ArrowRight,
  ArrowUp, Award, Book, Calendar, Check, CheckCircle, CheckSquare, ChevronDown, ChevronLeft,
  ChevronRight, ChevronUp, Chrome, Clipboard, Clock, CloudRain, Code, Copy, Delete, DollarSign,
  Download, Edit, Edit2, ExternalLink, Facebook, File, Filter, Globe, Home, Image, Info, Link,
  Mail, MapPin, Minus, Moon, MoreHorizontal, MoreVertical, Package, Phone, Play, Plus, Radio,
  RefreshCw, Repeat, RotateCcw, Save, Search, Send, Settings, Share, ShoppingCart, Sliders, Star,
  Sun, Tag, Trash, Trash2, Upload, User, Users, Wind, X, XCircle
} from "react-feather"

// No prototype, so `name in FEATHER_ICONS` is false for inherited keys like "constructor"
export const FEATHER_ICONS = Object.assign(Object.create(null), {
  AlertCircle, AlertTriangle, Anchor, Aperture, ArrowDown, ArrowDownCircle, ArrowLeft, ArrowRight,
  ArrowUp, Award, Book, Calendar, Check, CheckCircle, CheckSquare, ChevronDown, ChevronLeft,
  ChevronRight, ChevronUp, Chrome, Clipboard, Clock, CloudRain, Code, Copy, Delete, DollarSign,
  Download, Edit, Edit2, ExternalLink, Facebook, File, Filter, Globe, Home, Image, Info, Link,
  Mail, MapPin, Minus, Moon, MoreHorizontal, MoreVertical, Package, Phone, Play, Plus, Radio,
  RefreshCw, Repeat, RotateCcw, Save, Search, Send, Settings, Share, ShoppingCart, Sliders, Star,
  Sun, Tag, Trash, Trash2, Upload, User, Users, Wind, X, XCircle
})
